import React, { useMemo } from "react";
import { LineChart } from "@mui/x-charts";

interface DispLevelAndTempChartProps {
  data: any[];
  xKey: string;
  yKeys: string[];
  height?: number;
  width?: number;
}

const DispLevelAndTempChart: React.FC<DispLevelAndTempChartProps> = ({
  data,
  xKey,
  yKeys,
  height = 400,
  width = 800,
}) => {
  const xAxisData = data.map((item) => new Date(item[xKey]));

  const series = yKeys.map((yKey) => ({
    data: data.map((item) => item[yKey]),
    label: yKey,
    showMark: false,
    curve: "natural" as const,
  }));

  const [yMin, yMax] = useMemo(() => {
    if (!data.length) return [0, 0];
    const values = yKeys.flatMap((yKey) =>
      data.map((item) => item[yKey]).filter((v) => typeof v === "number")
    ) as number[];
    return [Math.min(...values) - 2, Math.max(...values) + 2];
  }, [data, yKeys]);

  return (
    <LineChart
      height={height}
      width={width}
      margin={{
        left: 80, // give labels breathing space
        right: 30,
        top: 30,
        bottom: 50,
      }}
      xAxis={[
        {
          scaleType: "time",
          data: xAxisData,
          label: "Time",
          valueFormatter: (date) =>
            date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        },
      ]}
      yAxis={[
        {
          scaleType: "linear",
          min: yMin,
          max: yMax,
          tickNumber: 6,
          valueFormatter: (value) => value.toLocaleString(),
          tickLabelStyle: {
            textOverflow: "visible",
            overflow: "visible",
            whiteSpace: "nowrap",
            fontSize: 12,
          },
        },
      ]}
      series={series}
      slotProps={{
        tooltip: { placement: "top", trigger: "axis" },
      }}
    />
  );
};

export default DispLevelAndTempChart;
